import type { Obj } from "#utils/UNSAFE_typeUtils";

// type guard function 
export const isObj = (v: unknown): v is Obj => typeof v === 'object';
